import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { verifyEmail } from '../../crud/emailVerification.crud';
import { get } from '../../crud/user.crud';
import * as authActions from '../../store/ducks/auth.duck';

function VerifyEmail({ user, fulfillUser }) {
    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const email = params.get('email');

        if (!token || !email) {
            setError(true);
            setLoading(false);
            return;
        }

        setLoading(true);

        verifyEmail(email, token)
            .then(async ({ data }) => {
                if (data?.errors) {
                    setError(true);
                    if (data?.errors[0]) {
                        Swal.fire('Ops!', data.errors[0], 'error');
                    }
                } else {
                    setVerified(true);
                    
                    // Se o usuário está logado, buscar perfil atualizado do backend ANTES do redirect
                    if (user && user.email === email && user.id) {
                        try {
                            const { data: profileData } = await get(user.id);
                            if (profileData) {
                                fulfillUser(profileData);
                            }
                        } catch (error) {
                            // Se falhar ao buscar perfil, atualizar manualmente
                            const updatedUser = { 
                                ...user, 
                                email_verified: true
                            };
                            fulfillUser(updatedUser);
                        }
                    }
                    
                    Swal.fire('Sucesso!', 'Email verificado com sucesso!', 'success').then(() => {
                        history.push('/');
                    });
                }
            })
            .catch(({ response }) => {
                setError(true);
                const errorMessage = response?.data?.errors?.[0] || 
                                    response?.data?.message || 
                                    'Erro ao verificar email. Tente novamente.';
                Swal.fire('Ops!', errorMessage, 'error');
            })
            .finally(() => {
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const content = () => {
        if (loading) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    padding: '20px'
                }}>
                    <i className='fa fa-spinner fa-spin' style={{ fontSize: 40, color: '#8C959B', marginBottom: '16px' }} />
                    <p style={{ textAlign: 'center', color: '#666' }}>Verificando seu email...</p>
                </div>
            );
        }

        if (verified) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    padding: '20px',
                    textAlign: 'center'
                }}>
                    <div style={{
                        width: '104px',
                        height: '104px',
                        borderRadius: '50%',
                        backgroundColor: '#E8F5E9',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '24px'
                    }}>
                        <i className="fa fa-check-circle" style={{ fontSize: 104, color: '#4CAF50' }} />
                    </div>

                    <h5 style={{ marginBottom: '16px', fontSize: '24px', fontWeight: 600 }}>Email Verificado!</h5>

                    <p style={{ color: '#666', marginBottom: '24px', maxWidth: '400px' }}>
                        Seu email foi verificado com sucesso. Você já pode usar todas as funcionalidades do sistema.
                    </p>

                    <button 
                        onClick={() => history.push('/')}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#284EEA',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 500
                        }}
                    >
                        Ir para o início
                    </button>
                </div>
            );
        }

        if (error) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    padding: '20px',
                    textAlign: 'center'
                }}>
                    <div style={{
                        width: '104px',
                        height: '104px',
                        borderRadius: '50%',
                        backgroundColor: '#FFEBEE',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '24px'
                    }}>
                        <i className="fa fa-times-circle" style={{ fontSize: 104, color: '#f44336' }} />
                    </div>

                    <h5 style={{ marginBottom: '16px', fontSize: '24px', fontWeight: 600 }}>Erro na Verificação</h5>

                    <p style={{ color: '#666', marginBottom: '24px', maxWidth: '400px' }}>
                        Não foi possível verificar seu email. O link pode ter expirado ou ser inválido.
                    </p>

                    <button 
                        onClick={() => history.push('/auth/login')}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#284EEA',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 500
                        }}
                    >
                        Voltar para o login
                    </button>
                </div>
            );
        }

        return null;
    }

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f5f5'
        }}>
            {content()}
        </div>
    );
}

const mapStateToProps = ({ auth: { user } }) => ({ user });

const mapDispatchToProps = {
    fulfillUser: authActions.actions.fulfillUser
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail);
